import Vue from 'vue'
import App from './App'

import axios from 'axios'
axios.defaults.baseURL = location.origin === "http://share.2861.wiki"? "http://share.2861.wiki/h5/0/": "http://192.168.0.52:9888/h5/0/";
Vue.prototype.$axios = axios;

import router from './router/router'

//配置微信分享
const package_desc = {
    cty: "2020年住建部城市体检第三方数据提供方",
    opn: "地区事件影响力和民众对热点话题的口碑分析",
    visual: "1/2861：服务一个区县，从全部2861个区县开始",
    space: "网格级的区域空间改造效果量化测评",
    cbd: "商圈配套与商圈人群的多维数据画像",
    popu: "实时人口数据覆盖全国所有省市区县、地理网格",
    website: "DaaS 由清华大学“智库2861”项目组发布，实时数据覆盖我国全部行政省市区县和每1平方公里网格。适合智库、高校、机构在宏观和商业领域的长周期分析。"
},
    pc_mode = window.screen.width < 415? false: true;
!pc_mode && router.beforeEach((to, from, next)=>{
    next();
    const package_id = to.path.substr(1) || "website",
        link = location.href; //分享地址
    axios.get("http://share.2861.wiki/zk2861/wechat/res.html?site_url=" + link).then(res => {
        let data = res.data;
        wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: [
                "updateAppMessageShareData",
                "onMenuShareTimeline",
                "updateTimelineShareData",
            ]
        });

        //微信公众号分享
        wx.ready(function (){
            wx.updateAppMessageShareData({ //分享好友
                link,
                title: document.title,
                imgUrl: `http://share.2861.wiki/res/img/${package_id}_cover.jpg`, //分享封面
                desc: package_desc[package_id], //分享描述
                success: function (){
                    console("success");
                }
            });
        })

    })
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js